/**
 * Below the patch-log modal (9000), above the app frame and the shell's Lumen
 * layers (500). The wizard is a Lumen Dialog; it takes this inline.
 */
export const ONBOARDING_MODAL_Z_INDEX = 8500;
